import { Box, Button, Typography } from '@mui/material';
import { onAuthStateChanged, sendEmailVerification } from 'firebase/auth';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/navbar.tsx';
import { auth } from '../firebase/config.tsx';
import Footer from '../components/footer.tsx';

interface EmailVerifyProps {
   navigationLink: string;
}

const EmailVerify: React.FC<EmailVerifyProps> = ({ navigationLink }) => {
  const navigateObj = useNavigate();
  const navigate = () => {
    auth.currentUser?.reload();
    navigateObj(navigationLink);
  };

  const [sendEmailDisabled, setIsDisabled] = React.useState(false);
  const resendConfirmation = () => {
    setIsDisabled(true);
    if (auth.currentUser) {
      sendEmailVerification(auth.currentUser)
        .then(() => {
          alert('email sent again. Please check your email.');
        }).catch((error) => {
          alert('Could not send email for verification. Please try again.');
          console.log('Error sending email', error);
        });
    }
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);
  };

  onAuthStateChanged(auth, (user) => {
    if (user) {
      if (user.emailVerified) {
        navigate();
      }
    }
  });

  return (
    <>
      <Navbar />
      <Box sx={{ width: '100%', justifyContent: 'center', marginTop: '5vh', justifyItems:'center' }}>
        <Typography variant="h4" style={{ justifyContent:'center', display: 'flex' }}>Account not verified yet.</Typography>
        <Typography variant="h4" style={{ justifyContent:'center', display: 'flex' }}>Please verify your Account</Typography>
        <Button variant="contained" style={{ backgroundColor: '#432a48', marginBottom: '3vh', marginTop: '2vh', textTransform: 'none' }} onClick={navigate}>Click Here Once Verified</Button>
        <Typography>If not received, <Button variant="text" style={{ textTransform: 'none', padding: '0', verticalAlign: 'unset' }} disableRipple onClick={resendConfirmation} disabled={sendEmailDisabled}>click here</Button> to resend.</Typography>
      </Box>
      <Footer />
    </>
  );
};

export default EmailVerify;